import {
  PaymentPolicyType,
  ReservationLocation,
  Unit,
} from '@wix/ambassador-table-reservations-v1-reservation-location/types'

import {defaultBusinessSchedule} from '../../utils/businessSchedule'

export const EDITOR_MOCK_RESERVATION_LOCATION_ID = 'editor-mock-reservation-location-id'
export const EDITOR_MOCK_AREA_ID = '11111111-1111-4111-8111-111111111111'
export const EDITOR_MOCK_SECOND_AREA_ID = '22222222-2222-4222-8222-222222222222'

export const reservationLocationMock: ReservationLocation = {
  id: EDITOR_MOCK_RESERVATION_LOCATION_ID,
  currency: 'USD',
  location: {
    id: 'id',
    name: 'San Francisco',
    timeZone: 'America/Los_Angeles',
    address: {
      country: 'US',
      subdivision: 'CA',
      city: 'San Francisco',
      formattedAddress: 'San Francisco, CA, USA',
      geocode: {
        latitude: 37.7749295,
        longitude: -122.4194155,
      },
    },
  },
  configuration: {
    reservationPayment: {
      value: '10',
      minPartySize: 1,
    },
    paymentPolicy: {
      paymentPolicyType: PaymentPolicyType.PER_RESERVATION,
      perReservationOptions: {
        price: '10',
        minPartySize: 1,
      },
    },
    onlineReservations: {
      partySize: {
        min: 1,
        max: 6,
      },
      minimumReservationNotice: {
        number: 30,
        unit: Unit.MINUTES,
      },
      turnoverTimeRules: [],
      onlineReservationsEnabled: true,
      businessSchedule: defaultBusinessSchedule,
    },
    areaConfiguration: {
      enabled: true,
      visibleToGuests: true,
      areas: [
        {
          id: EDITOR_MOCK_AREA_ID,
          name: 'Dining room',
          description: 'Classic indoor seating',
        },
        {
          id: EDITOR_MOCK_SECOND_AREA_ID,
          name: 'Patio',
          description: 'Outdoor seating',
        },
      ],
    },
    tableManagement: {
      tableDefinitions: [
        {
          id: 'table-1',
          name: 'Table 1',
          seatsMin: 1,
          seatsMax: 4,
          isActive: true,
          areaId: EDITOR_MOCK_AREA_ID,
        },
        {
          id: 'table-2',
          name: 'Table 2',
          seatsMin: 1,
          seatsMax: 4,
          isActive: true,
          areaId: EDITOR_MOCK_SECOND_AREA_ID,
        },
      ],
    },
  },
}
